import ServicePage from '../../components/service/ServicePage'

export default function AssemblyTrim() {
  return <ServicePage service="assembly" lang="en" />
}
